var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('LoadingMask'):_vm._e(),_c('ProductInfo',{attrs:{"edit":"true","contractAddr":_vm.$route.params.contractAddr}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }